<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  #formRef="ngForm"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          aria-controls="primaryTagFilter"
          ><span class="fs-3">
            {{ 'configurationOptionModule.primaryTagFilter' | translate }}</span
          >
          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div *ngIf="!isCollapsed" id="primaryTagFilter">
      <!-- SCHEDULE TABLE -->
      <div *ngIf="!(discoveryAreaConfigHasValue$ | async)" class="card-body">
        <h3 class="h4">{{ 'general.schedule' | translate }}</h3>
        <div class="table-responsive card-table">
          <table class="table border-bottom table-light table-sm">
            <thead>
              <tr>
                <th scope="col" id="orderLabel">
                  {{ 'configurationOptionModule.ordinal' | translate }}<br />
                </th>
                <th scope="col" id="activeStateLabel"
                  >{{ 'general.active' | translate }}<br
                /></th>
                <th scope="col" id="tagLevelLabel">
                  {{ 'configurationOptionModule.tagLevel' | translate }}<br />
                </th>
                <th
                  scope="col"
                  *ngIf="availableLanguages['nl']"
                  id="titleNlLabel"
                >
                  {{ 'general.title' | translate }}
                  <span
                    class="flag flag-nl ms-2"
                    role="img"
                    attr.aria-label="{{ 'wcag.nl' | translate }}"
                  ></span>
                </th>

                <th
                  scope="col"
                  *ngIf="availableLanguages['en']"
                  id="titleEnLabel"
                >
                  {{ 'general.title' | translate }}
                  <span
                    class="flag flag-en ms-2"
                    role="img"
                    attr.aria-label="{{ 'wcag.en' | translate }}"
                  ></span>
                </th>
                <th
                  scope="col"
                  *ngIf="availableLanguages['fr']"
                  id="titleFrLabel"
                >
                  {{ 'general.title' | translate }}
                  <span
                    class="flag flag-fr ms-2"
                    role="img"
                    attr.aria-label="{{ 'wcag.fr' | translate }}"
                  ></span>
                </th>

                <th
                  scope="col"
                  *ngIf="availableLanguages['de']"
                  id="titleDeLabel"
                >
                  {{ 'general.title' | translate }}
                  <span
                    class="flag flag-de ms-2"
                    role="img"
                    attr.aria-label="{{ 'wcag.de' | translate }}"
                  ></span>
                </th>

                <th scope="col"
                  ><span class="visually-hidden">{{
                    'general.actions' | translate
                  }}</span></th
                >
              </tr>
            </thead>
            <tbody
              formArrayName="configSets"
              *ngFor="
                let configSets of configSetsFormArray.controls;
                let i = index
              "
            >
              <tr [formGroupName]="i">
                <td>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="-"
                    aria-labelledby="orderLabel"
                    aria-describedby="orderError"
                    formControlName="ordinal"
                    [attr.aria-invalid]="
                      configSets.controls.ordinal.dirty &&
                      configSets.controls.ordinal.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="orderError"
                    *ngIf="
                      configSets.controls.ordinal.dirty &&
                      configSets.controls.ordinal.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>

                <td>
                  <input
                    type="checkbox"
                    aria-labelledby="activeStateLabel"
                    class="form-check-input"
                    formControlName="activeState"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="-"
                    formControlName="tagLevel"
                    aria-labelledby="tagLevelLabel"
                    aria-describedby="tagLevelError"
                    [attr.aria-invalid]="
                      configSets.controls.tagLevel.dirty &&
                      configSets.controls.tagLevel.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="tagLevelError"
                    *ngIf="
                      configSets.controls.tagLevel.dirty &&
                      configSets.controls.tagLevel.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>
                <td *ngIf="availableLanguages['nl']">
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="titleNlLabel"
                    placeholder="title_nl"
                    formControlName="title_nl"
                    aria-describedby="titleNlError"
                    [attr.aria-invalid]="
                      configSets.controls.title_nl.dirty &&
                      configSets.controls.title_nl.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="titleNlError"
                    *ngIf="
                      configSets.controls.title_nl.dirty &&
                      configSets.controls.title_nl.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>

                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>
                <td *ngIf="availableLanguages['en']">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="title_en"
                    formControlName="title_en"
                    aria-labelledby="titleEnLabel"
                    aria-describedby="titleEnError"
                    [attr.aria-invalid]="
                      configSets.controls.title_en.dirty &&
                      configSets.controls.title_en.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="titleEnError"
                    *ngIf="
                      configSets.controls.title_en.dirty &&
                      configSets.controls.title_en.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>
                <td *ngIf="availableLanguages['fr']">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="title_fr"
                    formControlName="title_fr"
                    aria-labelledby="titleFrLabel"
                    aria-describedby="titleFrError"
                    [attr.aria-invalid]="
                      configSets.controls.title_fr.dirty &&
                      configSets.controls.title_fr.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="titleFrError"
                    *ngIf="
                      configSets.controls.title_fr.dirty &&
                      configSets.controls.title_fr.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>

                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>
                <td *ngIf="availableLanguages['de']">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="title_de"
                    formControlName="title_de"
                    aria-labelledby="titleDeLabel"
                    aria-describedby="titleDeError"
                    [attr.aria-invalid]="
                      configSets.controls.title_de.dirty &&
                      configSets.controls.title_de.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="titleDeError"
                    *ngIf="
                      configSets.controls.title_de.dirty &&
                      configSets.controls.title_de.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>
                <td>
                  <button
                    class="btn btn-ghost-secondary"
                    type="button"
                    [canSee]="[accessRights.ConfigurationOptions_delete]"
                    (click)="deleteConfigSetRow(configSetsFormArray, i)"
                  >
                    <i
                      role="img"
                      class="fa fa-trash-alt"
                      attr.aria-label="{{ 'general.delete' | translate }}"
                    ></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-start pb-3">
          <button
            class="btn btn-soft-primary btn-sm"
            type="button"
            (click)="addConfigSetRow(configSetsFormArray)"
            [canSee]="[accessRights.Settings_write]"
            [canSee]="[accessRights.ConfigurationOptions_write]"
          >
            {{ 'general.addRow' | translate }}
          </button>
        </div>
      </div>

      <!-- START COURSE TABLE -->
      <div *ngIf="!(discoveryAreaConfigHasValue$ | async)" class="card-body">
        <h3 class="h4">
          {{ 'shopModule.shop' | translate }} -
          {{ 'courseModule.courses' | translate }}
        </h3>
        <div class="table-responsive card-table">
          <table class="table border-bottom table-light table-sm">
            <thead>
              <tr>
                <th scope="col" id="shopOrdLabel">
                  {{ 'configurationOptionModule.ordinal' | translate }}<br />
                </th>
                <th scope="col" id="shopActiveLabel"
                  >{{ 'general.active' | translate }}<br
                /></th>
                <th scope="col" id="shopTagLevelLabel">
                  {{ 'configurationOptionModule.tagLevel' | translate }}<br />
                </th>
                <th
                  scope="col"
                  *ngIf="availableLanguages['nl']"
                  id="shopTitleNl"
                >
                  {{ 'general.title' | translate }}
                  <span
                    class="flag flag-nl ms-2"
                    role="img"
                    attr.aria-label="{{ 'wcag.nl' | translate }}"
                  ></span>
                </th>
                <th
                  scope="col"
                  *ngIf="availableLanguages['en']"
                  id="shopTitleEn"
                >
                  {{ 'general.title' | translate }}
                  <span
                    class="flag flag-en ms-2"
                    role="img"
                    attr.aria-label="{{ 'wcag.en' | translate }}"
                  ></span>
                </th>
                <th
                  scope="col"
                  *ngIf="availableLanguages['fr']"
                  id="shopTitleFr"
                >
                  {{ 'general.title' | translate }}
                  <span
                    class="flag flag-fr ms-2 ms-2"
                    role="img"
                    attr.aria-label="{{ 'wcag.fr' | translate }}"
                  ></span>
                </th>
                <th
                  scope="col"
                  *ngIf="availableLanguages['de']"
                  id="shopTitleDe"
                >
                  {{ 'general.title' | translate }}
                  <span
                    class="flag flag-de ms-2"
                    role="img"
                    attr.aria-label="{{ 'wcag.de' | translate }}"
                  ></span>
                </th>

                <th scope="col"
                  ><span class="visually-hidden">{{
                    'general.actions' | translate
                  }}</span></th
                >
              </tr>
            </thead>
            <tbody
              formArrayName="configSetsCourses"
              *ngFor="
                let configSets of configSetsCoursesFormArray.controls;
                let i = index
              "
            >
              <tr [formGroupName]="i">
                <td>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="-"
                    aria-labelledby="shopOrdLabel"
                    aria-describedby="shopOrdError"
                    formControlName="ordinal"
                    [attr.aria-invalid]="
                      this.form?.controls.ordinal?.dirty &&
                      this.form?.controls.ordinal?.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="shopOrdError"
                    *ngIf="
                      this.form?.controls.ordinal?.dirty &&
                      this.form?.controls.ordinal?.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>

                <td>
                  <input
                    type="checkbox"
                    aria-labelledby="shopActiveLabel"
                    class="form-check-input"
                    formControlName="activeState"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="-"
                    formControlName="tagLevel"
                    aria-labelledby="shopTagLevelLabel"
                    aria-describedby="shopTagLebelError"
                    [attr.aria-invalid]="
                      this.form?.controls.tagLevel?.dirty &&
                      this.form?.controls.tagLevel?.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="shopTagLebelError"
                    *ngIf="
                      this.form?.controls.tagLevel?.dirty &&
                      this.form?.controls.tagLevel.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>
                <td *ngIf="availableLanguages['nl']">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="title_nl"
                    aria-labelledby="shopTitleNl"
                    aria-describedby="shopTitleNlError"
                    formControlName="title_nl"
                    [attr.aria-invalid]="
                      configSets.controls.title_nl.dirty &&
                      configSets.controls.title_nl.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="shopTitleNlError"
                    *ngIf="
                      configSets.controls.title_nl.dirty &&
                      configSets.controls.title_nl.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>
                <td *ngIf="availableLanguages['en']">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="title_en"
                    formControlName="title_en"
                    aria-labelledby="shopTitleEn"
                    aria-describedby="shopTitleEnError"
                    [attr.aria-invalid]="
                      configSets.controls.title_en.dirty &&
                      configSets.controls.title_en.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="shopTitleEnError"
                    *ngIf="
                      configSets.controls.title_en.dirty &&
                      configSets.controls.title_en.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>
                <td *ngIf="availableLanguages['fr']">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="title_fr"
                    formControlName="title_fr"
                    aria-labelledby="shopTitleFr"
                    aria-describedby="shopTitleFrError"
                    [attr.aria-invalid]="
                      configSets.controls.title_fr.dirty &&
                      configSets.controls.title_fr.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="shopTitleFrError"
                    *ngIf="
                      configSets.controls.title_fr.dirty &&
                      configSets.controls.title_fr.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>

                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>
                <td *ngIf="availableLanguages['de']">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="title_de"
                    formControlName="title_de"
                    aria-labelledby="shopTitleDe"
                    aria-describedby="shopTitleDeError"
                    [attr.aria-invalid]="
                      configSets.controls.title_de.dirty &&
                      configSets.controls.title_de.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="shopTitleDeError"
                    *ngIf="
                      configSets.controls.title_de.dirty &&
                      configSets.controls.title_de.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>

                <td>
                  <button
                    type="button"
                    class="btn btn-ghost-secondary"
                    (click)="deleteConfigSetRow(configSetsCoursesFormArray, i)"
                    [canSee]="[accessRights.ConfigurationOptions_delete]"
                  >
                    <i
                      role="img"
                      class="fa fa-trash-alt"
                      attr.aria-label="{{ 'general.delete' | translate }}"
                    ></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-start pb-3">
          <button
            class="btn btn-soft-primary btn-sm"
            type="button"
            (click)="addConfigSetRow(configSetsCoursesFormArray)"
            [canSee]="[accessRights.Settings_write]"
            [canSee]="[accessRights.ConfigurationOptions_write]"
          >
            {{ 'general.addRow' | translate }}
          </button>
        </div>
      </div>
      <!-- END COURSE TABLE -->

      <!-- START SUBSCRIPTIONS TABLE -->
      <div class="card-body">
        <h3 class="h4">
          {{ 'shopModule.shop' | translate }} -
          {{ 'subscriptionModule.subscriptions' | translate }}
        </h3>
        <div class="table-responsive card-table">
          <table class="table border-bottom table-light table-sm">
            <thead>
              <tr>
                <th scope="col" id="subsOrderLabel">
                  {{ 'configurationOptionModule.ordinal' | translate }}<br />
                </th>
                <th scope="col" id="subsActiveLabel"
                  >{{ 'general.active' | translate }}<br
                /></th>
                <th scope="col" id="subsTagLevelLabel">
                  {{ 'configurationOptionModule.tagLevel' | translate }}<br />
                </th>
                <th
                  scope="col"
                  *ngIf="availableLanguages['nl']"
                  id="subsTitleNl"
                >
                  {{ 'general.title' | translate }}
                  <span
                    class="flag flag-nl ms-2"
                    role="img"
                    attr.aria-label="{{ 'wcag.nl' | translate }}"
                  ></span>
                </th>
                <th
                  scope="col"
                  *ngIf="availableLanguages['en']"
                  id="subsTitleEn"
                >
                  {{ 'general.title' | translate }}
                  <span
                    class="flag flag-en ms-2"
                    role="img"
                    attr.aria-label="{{ 'wcag.en' | translate }}"
                  ></span>
                </th>
                <th
                  scope="col"
                  *ngIf="availableLanguages['fr']"
                  id="subsTitleFr"
                >
                  {{ 'general.title' | translate }}
                  <span
                    class="flag flag-fr ms-2"
                    role="img"
                    attr.aria-label="{{ 'wcag.fr' | translate }}"
                  ></span>
                </th>

                <th
                  scope="col"
                  *ngIf="availableLanguages['de']"
                  id="subsTitleDe"
                >
                  {{ 'general.title' | translate }}
                  <span
                    class="flag flag-de ms-2"
                    role="img"
                    attr.aria-label="{{ 'wcag.de' | translate }}"
                  ></span>
                </th>

                <th scope="col"
                  ><span class="visually-hidden">{{
                    'general.actions' | translate
                  }}</span></th
                >
              </tr>
            </thead>
            <tbody
              formArrayName="configSetsSubscriptions"
              *ngFor="
                let configSets of configSetsSubscriptionsFormArray.controls;
                let i = index
              "
            >
              <tr [formGroupName]="i">
                <td>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="-"
                    formControlName="ordinal"
                    aria-labelledby="subsOrderLabel"
                    aria-describedby="subsOrderError"
                    [attr.aria-invalid]="
                      configSets.controls.ordinal.dirty &&
                      configSets.controls.ordinal.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="subsOrderError"
                    *ngIf="
                      configSets.controls.ordinal.dirty &&
                      configSets.controls.ordinal.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>

                <td>
                  <input
                    type="checkbox"
                    class="form-check-input"
                    aria-labelledby="subsActiveLabel"
                    formControlName="activeState"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="-"
                    formControlName="tagLevel"
                    aria-labelledby="subsTagLevelLabel"
                    aria-describedby="subsTagError"
                    [attr.aria-invalid]="
                      configSets.controls.tagLevel.dirty &&
                      configSets.controls.tagLevel.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="subsTagError"
                    *ngIf="
                      configSets.controls.tagLevel.dirty &&
                      configSets.controls.tagLevel.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>
                <td *ngIf="availableLanguages['nl']">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="title_nl"
                    formControlName="title_nl"
                    aria-labelledby="subsTitleNl"
                    aria-describedby="subsTitleNlError"
                    [attr.aria-invalid]="
                      configSets.controls.title_nl.dirty &&
                      configSets.controls.title_nl.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="subsTitleNlError"
                    *ngIf="
                      configSets.controls.title_nl.dirty &&
                      configSets.controls.title_nl.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>
                <td *ngIf="availableLanguages['en']">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="title_en"
                    formControlName="title_en"
                    aria-labelledby="subsTitleNl"
                    aria-describedby="subsTitleEnError"
                    [attr.aria-invalid]="
                      configSets.controls.title_en.dirty &&
                      configSets.controls.title_en.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="subsTitleEnError"
                    *ngIf="
                      configSets.controls.title_en.dirty &&
                      configSets.controls.title_en.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>
                <td *ngIf="availableLanguages['fr']">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="title_fr"
                    formControlName="title_fr"
                    aria-labelledby="subsTitleFr"
                    aria-describedby="subsTitleFrError"
                    [attr.aria-invalid]="
                      configSets.controls.title_fr.dirty &&
                      configSets.controls.title_fr.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="subsTitleFrError"
                    *ngIf="
                      configSets.controls.title_fr.dirty &&
                      configSets.controls.title_fr.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>

                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>
                <td *ngIf="availableLanguages['de']">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="title_de"
                    formControlName="title_de"
                    aria-labelledby="subsTitleDe"
                    aria-describedby="subsTitleDeError"
                    [attr.aria-invalid]="
                      configSets.controls.title_de.dirty &&
                      configSets.controls.title_de.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="subsTitleDeError"
                    *ngIf="
                      configSets.controls.title_de.dirty &&
                      configSets.controls.title_de.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>

                <td>
                  <button
                    type="button"
                    class="btn btn-ghost-secondary"
                    (click)="
                      deleteConfigSetRow(configSetsSubscriptionsFormArray, i)
                    "
                    [canSee]="[accessRights.ConfigurationOptions_delete]"
                  >
                    <i
                      role="img"
                      class="fa fa-trash-alt"
                      attr.aria-label="{{ 'general.delete' | translate }}"
                    ></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-start pb-3">
          <button
            class="btn btn-soft-primary btn-sm"
            type="button"
            (click)="addConfigSetRow(configSetsSubscriptionsFormArray)"
            [canSee]="[accessRights.Settings_write]"
            [canSee]="[accessRights.ConfigurationOptions_write]"
          >
            {{ 'general.addRow' | translate }}
          </button>
        </div>
      </div>

      <!-- END SUBSCRIPTIONS TABLE -->

      <!-- START RENTALS TABLE -->
      <div class="card-body">
        <h3 class="h4">
          {{ 'shopModule.shop' | translate }} -
          {{ 'rentalModule.rentals' | translate }}
        </h3>
        <div class="table-responsive card-table">
          <table class="table border-bottom table-light table-sm">
            <thead>
              <tr>
                <th scope="col" id="rentalsOrderLabel">
                  {{ 'configurationOptionModule.ordinal' | translate }}<br />
                </th>
                <th scope="col" id="rentalsActiveLabel"
                  >{{ 'general.active' | translate }}<br
                /></th>
                <th scope="col" id="rentalsTagLevelLabel">
                  {{ 'configurationOptionModule.tagLevel' | translate }}<br />
                </th>
                <th
                  scope="col"
                  *ngIf="availableLanguages['nl']"
                  id="rentalsTitleNl"
                >
                  {{ 'general.title' | translate }}
                  <span
                    class="flag flag-nl ms-2"
                    role="img"
                    attr.aria-label="{{ 'wcag.nl' | translate }}"
                  ></span>
                </th>
                <th
                  scope="col"
                  *ngIf="availableLanguages['en']"
                  id="rentalsTitleEn"
                >
                  {{ 'general.title' | translate }}
                  <span
                    class="flag flag-en ms-2"
                    role="img"
                    attr.aria-label="{{ 'wcag.en' | translate }}"
                  ></span>
                </th>
                <th
                  scope="col"
                  *ngIf="availableLanguages['fr']"
                  id="rentalsTitleFr"
                >
                  {{ 'general.title' | translate }}
                  <span
                    class="flag flag-fr ms-2"
                    role="img"
                    attr.aria-label="{{ 'wcag.fr' | translate }}"
                  ></span>
                </th>

                <th
                  scope="col"
                  *ngIf="availableLanguages['de']"
                  id="rentalsTitleDe"
                >
                  {{ 'general.title' | translate }}
                  <span
                    class="flag flag-de ms-2"
                    role="img"
                    attr.aria-label="{{ 'wcag.de' | translate }}"
                  ></span>
                </th>

                <th scope="col"
                  ><span class="visually-hidden">{{
                    'general.actions' | translate
                  }}</span></th
                >
              </tr>
            </thead>
            <tbody
              formArrayName="configSetsRentals"
              *ngFor="
                let configSets of configSetsRentalsFormArray.controls;
                let i = index
              "
            >
              <tr [formGroupName]="i">
                <td>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="-"
                    formControlName="ordinal"
                    aria-labelledby="rentalsOrderLabel"
                    aria-describedby="rentalsOrderError"
                    [attr.aria-invalid]="
                      configSets.controls.ordinal.dirty &&
                      configSets.controls.ordinal.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="rentalsOrderError"
                    *ngIf="
                      configSets.controls.ordinal.dirty &&
                      configSets.controls.ordinal.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>

                <td>
                  <input
                    type="checkbox"
                    class="form-check-input"
                    aria-labelledby="rentalsActiveLabel"
                    formControlName="activeState"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="-"
                    formControlName="tagLevel"
                    aria-labelledby="rentalsTagLevelLabel"
                    aria-describedby="rentalsTagError"
                    [attr.aria-invalid]="
                      configSets.controls.tagLevel.dirty &&
                      configSets.controls.tagLevel.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="rentalsTagError"
                    *ngIf="
                      configSets.controls.tagLevel.dirty &&
                      configSets.controls.tagLevel.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>
                <td *ngIf="availableLanguages['nl']">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="title_nl"
                    formControlName="title_nl"
                    aria-labelledby="rentalsTitleNl"
                    aria-describedby="rentalsTitleNlError"
                    [attr.aria-invalid]="
                      configSets.controls.title_nl.dirty &&
                      configSets.controls.title_nl.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="rentalsTitleNlError"
                    *ngIf="
                      configSets.controls.title_nl.dirty &&
                      configSets.controls.title_nl.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>
                <td *ngIf="availableLanguages['en']">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="title_en"
                    formControlName="title_en"
                    aria-labelledby="rentalsTitleNl"
                    aria-describedby="rentalsTitleEnError"
                    [attr.aria-invalid]="
                      configSets.controls.title_en.dirty &&
                      configSets.controls.title_en.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="rentalsTitleEnError"
                    *ngIf="
                      configSets.controls.title_en.dirty &&
                      configSets.controls.title_en.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>
                <td *ngIf="availableLanguages['fr']">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="title_fr"
                    formControlName="title_fr"
                    aria-labelledby="rentalsTitleFr"
                    aria-describedby="rentalsTitleFrError"
                    [attr.aria-invalid]="
                      configSets.controls.title_fr.dirty &&
                      configSets.controls.title_fr.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="rentalsTitleFrError"
                    *ngIf="
                      configSets.controls.title_fr.dirty &&
                      configSets.controls.title_fr.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>

                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>
                <td *ngIf="availableLanguages['de']">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="title_de"
                    formControlName="title_de"
                    aria-labelledby="rentalsTitleDe"
                    aria-describedby="rentalsTitleDeError"
                    [attr.aria-invalid]="
                      configSets.controls.title_de.dirty &&
                      configSets.controls.title_de.invalid
                        ? 'true'
                        : null
                    "
                  />

                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    id="rentalsTitleDeError"
                    *ngIf="
                      configSets.controls.title_de.dirty &&
                      configSets.controls.title_de.invalid
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p>
                </td>

                <td>
                  <button
                    type="button"
                    class="btn btn-ghost-secondary"
                    (click)="deleteConfigSetRow(configSetsRentalsFormArray, i)"
                    [canSee]="[accessRights.ConfigurationOptions_delete]"
                  >
                    <i
                      role="img"
                      class="fa fa-trash-alt"
                      attr.aria-label="{{ 'general.delete' | translate }}"
                    ></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-start pb-3">
          <button
            class="btn btn-soft-primary btn-sm"
            type="button"
            (click)="addConfigSetRow(configSetsRentalsFormArray)"
            [canSee]="[accessRights.Settings_write]"
            [canSee]="[accessRights.ConfigurationOptions_write]"
          >
            {{ 'general.addRow' | translate }}
          </button>
        </div>
      </div>

      <!-- END RENTALS TABLE -->

      <!-- START: EXAMPLE TAGS -->
      <div class="card-body">
        <h4>
          {{
            'general.exampleTagIds'
              | translate
              | replaceVarInString
                : '$$MAX_NUM_OF_TAGS$$'
                : maxNumberOfExampleTags.toString()
          }}
        </h4>

        <!-- START: TAGFILTER EXAMPLE IDS (SCHEDULE) -->
        <div *ngIf="!(discoveryAreaConfigHasValue$ | async)" class="mb-4">
          <label class="form-label">
            {{ 'productModule.schedule' | translate }}
          </label>

          <ng-select
            *ngIf="tags$ | async"
            [items]="sortTags(tags$ | async)"
            [multiple]="true"
            [closeOnSelect]="false"
            [searchable]="true"
            formControlName="exampleTagIds"
            bindLabel="description"
            bindValue="id"
            placeholder="{{ 'tagModule.selectTag' | translate }}"
            [clearSearchOnAdd]="true"
          >
          </ng-select>
          <p
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              form.controls.exampleTagIds.dirty &&
              form.controls.exampleTagIds.errors &&
              form.controls.exampleTagIds.errors.tooManySelected
            "
          >
            <i
              role="img"
              class="fas fa-exclamation-circle"
              aria-hidden="true"
            ></i>
            {{ 'configurationOptionModule.tooManyTagsSelected' | translate }}:
            {{ form.controls.exampleTagIds.errors.tooManySelected }}
          </p>
        </div>
        <!-- END: TAGFILTER EXAMPLE IDS (SCHEDULE) -->

        <!-- START: TAGFILTER EXAMPLE IDS (COURSES) -->
        <div *ngIf="!(discoveryAreaConfigHasValue$ | async)" class="mb-4">
          <label class="form-label">
            {{ 'shopModule.shop' | translate }} -
            {{ 'courseModule.courses' | translate }}
          </label>

          <ng-select
            *ngIf="tags$ | async"
            [items]="sortTags(tags$ | async)"
            [multiple]="true"
            [closeOnSelect]="false"
            [searchable]="true"
            formControlName="exampleTagIdsCourses"
            bindLabel="description"
            bindValue="id"
            placeholder="{{ 'tagModule.selectTag' | translate }}"
            [clearSearchOnAdd]="true"
          >
          </ng-select>
          <p
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              form.controls.exampleTagIdsCourses.dirty &&
              form.controls.exampleTagIdsCourses.errors &&
              form.controls.exampleTagIdsCourses.errors.tooManySelected
            "
          >
            <i
              role="img"
              class="fas fa-exclamation-circle"
              aria-hidden="true"
            ></i>
            {{ 'configurationOptionModule.tooManyTagsSelected' | translate }}:
            {{ form.controls.exampleTagIdsCourses.errors.tooManySelected }}
          </p>
        </div>
        <!-- END: TAGFILTER EXAMPLE IDS (COURSES) -->

        <!-- START: TAGFILTER EXAMPLE IDS (SUBSCRIPTIONS) -->
        <div class="mb-4">
          <label class="form-label">
            {{ 'shopModule.shop' | translate }} -
            {{ 'subscriptionModule.subscriptions' | translate }}
          </label>

          <ng-select
            *ngIf="tags$ | async"
            [items]="sortTags(tags$ | async)"
            [multiple]="true"
            [closeOnSelect]="false"
            [searchable]="true"
            formControlName="exampleTagIdsSubscriptions"
            bindLabel="description"
            bindValue="id"
            placeholder="{{ 'tagModule.selectTag' | translate }}"
            [clearSearchOnAdd]="true"
          >
          </ng-select>
          <p
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              form.controls.exampleTagIdsSubscriptions.dirty &&
              form.controls.exampleTagIdsSubscriptions.errors &&
              form.controls.exampleTagIdsSubscriptions.errors.tooManySelected
            "
          >
            <i
              role="img"
              class="fas fa-exclamation-circle"
              aria-hidden="true"
            ></i>
            {{ 'configurationOptionModule.tooManyTagsSelected' | translate }}:
            {{
              form.controls.exampleTagIdsSubscriptions.errors.tooManySelected
            }}
          </p>
        </div>
        <!-- END: TAGFILTER EXAMPLE IDS (SUBSCRIPTIONS) -->

        <!-- START: TAGFILTER EXAMPLE IDS (RENTALS) -->
        <div class="mb-4">
          <label class="form-label">
            {{ 'shopModule.shop' | translate }} -
            {{ 'rentalModule.rentals' | translate }}
          </label>

          <ng-select
            *ngIf="tags$ | async"
            [items]="sortTags(tags$ | async)"
            [multiple]="true"
            [closeOnSelect]="false"
            [searchable]="true"
            formControlName="exampleTagIdsRentals"
            bindLabel="description"
            bindValue="id"
            placeholder="{{ 'tagModule.selectTag' | translate }}"
            [clearSearchOnAdd]="true"
          >
          </ng-select>
          <p
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              form.controls.exampleTagIdsRentals.dirty &&
              form.controls.exampleTagIdsRentals.errors &&
              form.controls.exampleTagIdsRentals.errors.tooManySelected
            "
          >
            <i
              role="img"
              class="fas fa-exclamation-circle"
              aria-hidden="true"
            ></i>
            {{ 'configurationOptionModule.tooManyTagsSelected' | translate }}:
            {{ form.controls.exampleTagIdsRentals.errors.tooManySelected }}
          </p>
        </div>
        <!-- END: TAGFILTER EXAMPLE IDS (RENTALS) -->
      </div>

      <div class="form-footer sticky-bottom card-body">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
  <!-- End Card -->
</form>
